// SPDX-FileCopyrightText: 2017-2022 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
export default function saveFile(blob: Blob, filename: string): void {
  if (!(blob instanceof Blob) || blob.size === 0) {
    throw new Error(`saveFile: invalid blob (size=${blob?.size ?? 'undefined'})`);
  }
  const objectData = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectData;
  link.download = filename;
  link.click();
  // For Firefox it is necessary to delay revoking the ObjectURL.
  setTimeout(() => URL.revokeObjectURL(objectData), 600);
}
